import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import { UtilService } from 'src/app/service/util';
import { ProcessoCadastro } from '../interface/processo-cadastro';
import { ProcessoCadastroRevisaoClienteFornecedorLista } from '../interface/processo-revisao-cadastro-cliente-fornecedor';
import { ProcessoCadastroRevisaoCliente } from '../interface/processo-revisao-cadastro-cliente';
import { ProcessoCadastroRevisaoFornecedor } from '../interface/processo-revisao-cadastro-fornecedor';
import { ProcessoCadastroHistorico, ProcessoCadastroHistoricoList } from '../interface/processo-cadastro-historico';
import { ProcessoPreCadastroProduto, ProcessoPreCadastroProdutoDto, ProcessoPreCadastroProdutoLista } from '../interface/processo-pre-cadastro-produto';
import { ProcessoPreCadastroCliente, ProcessoPreCadastroClienteDto, ProcessoPreCadastroClienteLista } from '../interface/processo-pre-cadastro-cliente';
import { ProcessoPreCadastroFornecedor, ProcessoPreCadastroFornecedorDto, ProcessoPreCadastroFornecedorLista } from '../interface/processo-pre-cadastro-fornecedor';
import { FiltroProcessoValidacaoClienteFornecedor, ProcessoValidacaoClienteFornecedorHistoricoLista, ProcessoValidacaoClienteFornecedorLista } from '../interface/processo-validacao-cliente-fornecedor';
import { ProcessoPreCadastroProdutoPdm, ProcessoPreCadastroProdutoPdmDto, ProcessoPreCadastroProdutoPdmLista } from '../interface/processo-pre-cadastro-produto-pdm';
import { AtualizacaoCadastroDto } from '../interface/atualizacao-cadastro';
import { IFiltroAtualizacaoCadastro } from '../interface/atualizacao-cadastro-filtro';

@Injectable({
  providedIn: 'root'
})
export class ProcessoCadastroService {
  url = `${environment.urlApiProtheus}/wsrproccadastro`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService) {
  }


  getProcCadastro(NCODIGO: number): Observable<ProcessoCadastro> {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.get<ProcessoCadastro>(`${this.url}/${NCODIGO}`, httpOptions);
  }

  getProcCadastroRevisaoClienteFornecedorLista(filtro: {}): Observable<ProcessoCadastroRevisaoClienteFornecedorLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<ProcessoCadastroRevisaoClienteFornecedorLista>(`${this.url}/revisao-cliente-fornecedor`, httpOptions);
  }

  getClienteSA1(chave: string): Observable<ProcessoCadastroRevisaoCliente> {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.get<ProcessoCadastroRevisaoCliente>(`${this.url}/clientesa1/${chave}`,httpOptions);
  }

  getProcCadastroCliente(codigoProcesso: number): Observable<ProcessoCadastroRevisaoCliente> {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.get<ProcessoCadastroRevisaoCliente>(`${this.url}/cliente/${codigoProcesso}`, httpOptions);
  }

  postClienteTemporario(cliente: ProcessoCadastroRevisaoCliente) {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/cliente/`, cliente, httpOptions);
  }

  getFornecedorSA2(chave: string): Observable<ProcessoCadastroRevisaoFornecedor> {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.get<ProcessoCadastroRevisaoFornecedor>(`${this.url}/fornecedorsa2/${chave}`,httpOptions);
  }

  getProcCadastroFornecedor(codigoProcesso: number): Observable<ProcessoCadastroRevisaoFornecedor> {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.get<ProcessoCadastroRevisaoFornecedor>(`${this.url}/fornecedor/${codigoProcesso}`, httpOptions);
  }

  postFornecedorTemporario(fornecedor: ProcessoCadastroRevisaoFornecedor) {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/fornecedor/`, fornecedor, httpOptions);
  }

  getProcCadastroHistoricoLista(codigoProcesso: number): Observable<ProcessoCadastroHistoricoList> {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.get<ProcessoCadastroHistoricoList>(`${this.url}/historico/lista/${codigoProcesso}`, httpOptions);
  }

  postHistorico(historico: ProcessoCadastroHistorico) {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/historico/`, historico, httpOptions);
  }

  postClienteRejeitar(NCODIGO: number, observacaoRejeicao: string) {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/cliente/rejeitar`, {NCODIGO: NCODIGO, COBSERVACAOREJEICAO: observacaoRejeicao}, httpOptions);
  }

  postFornecedorRejeitar(NCODIGO: number, observacaoRejeicao: string) {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/fornecedor/rejeitar`, {NCODIGO: NCODIGO, COBSERVACAOREJEICAO: observacaoRejeicao}, httpOptions);
  }



  // pre produto
  getProcCadastroPreProdutoLista(filtro: {}): Observable<ProcessoPreCadastroProdutoLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<ProcessoPreCadastroProdutoLista>(`${this.url}/pre/produto`, httpOptions);
  }

  getProcCadastroPreProduto(NCODIGO: number): Observable<ProcessoPreCadastroProduto> {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.get<ProcessoPreCadastroProduto>(`${this.url}/pre/produto/${NCODIGO}`, httpOptions);
  }

  postProcCadastroPreProduto(dados: ProcessoPreCadastroProdutoDto){
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/pre/produto`, dados, httpOptions);
  }
  postProcCadastroRevisaoProduto(dados: ProcessoPreCadastroProdutoDto){
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/revisao/produto`, dados, httpOptions);
  }



  // pre produto pdm
  getProcCadastroPreProdutoPdmLista(filtro: {}): Observable<ProcessoPreCadastroProdutoPdmLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<ProcessoPreCadastroProdutoLista>(`${this.url}/pre/produto-pdm`, httpOptions);
  }

  getProcCadastroPreProdutoPdm(NCODIGO: number): Observable<ProcessoPreCadastroProdutoPdm> {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.get<ProcessoPreCadastroProdutoPdm>(`${this.url}/pre/produto-pdm/${NCODIGO}`, httpOptions);
  }

  // produtos similares
  postProdutosSimilares(dados: ProcessoPreCadastroProdutoPdmDto){
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/produtos-similares`, dados, httpOptions);
  }

  postProcCadastroPreProdutoPdm(dados: ProcessoPreCadastroProdutoPdmDto){
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/pre/produto-pdm`, dados, httpOptions);
  }
  postProcCadastroRevisaoProdutoPdm(dados: ProcessoPreCadastroProdutoPdmDto){
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/revisao/produto-pdm`, dados, httpOptions);
  }


  // pre cliente
  getProcCadastroPreClienteLista(filtro: {}): Observable<ProcessoPreCadastroClienteLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<ProcessoPreCadastroClienteLista>(`${this.url}/pre/cliente`, httpOptions);
  }

  getProcCadastroPreCliente(NCODIGO: number): Observable<ProcessoPreCadastroCliente> {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.get<ProcessoPreCadastroCliente>(`${this.url}/pre/cliente/${NCODIGO}`, httpOptions);
  }

  postProcCadastroPreCliente(dados: ProcessoPreCadastroClienteDto) {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/pre/cliente`, dados, httpOptions);
  }

  // pre fornecedor
  getProcCadastroPreFornecedorLista(filtro: {}): Observable<ProcessoPreCadastroFornecedorLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<ProcessoPreCadastroFornecedorLista>(`${this.url}/pre/fornecedor`, httpOptions);
  }

  getProcCadastroPreFornecedor(NCODIGO: number): Observable<ProcessoPreCadastroFornecedor> {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.get<ProcessoPreCadastroFornecedor>(`${this.url}/pre/fornecedor/${NCODIGO}`, httpOptions);
  }

  postProcCadastroPreFornecedor(dados: ProcessoPreCadastroFornecedorDto) {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/pre/fornecedor`, dados, httpOptions);
  }

  // Validação Cliente/Fornecedor
  getAvaliaCadastroCliFor(filtro: FiltroProcessoValidacaoClienteFornecedor): Observable<ProcessoValidacaoClienteFornecedorLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<ProcessoValidacaoClienteFornecedorLista>(`${this.url}/avaliacao/cliente-fornecedor`, httpOptions);
  }

  getHistoricoCadastroCliFor(filtro: FiltroProcessoValidacaoClienteFornecedor): Observable<ProcessoValidacaoClienteFornecedorHistoricoLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<ProcessoValidacaoClienteFornecedorHistoricoLista>(`${this.url}/avaliacao/cliente-fornecedor/historico`, httpOptions);
  }

  postDesbloquearCadastroCliFor(NRECNO: number, CCADASTRO: string, CJUSTIFICATIVA: string) {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/avaliacao/cliente-fornecedor/desbloquear/${NRECNO}/${CCADASTRO}/${CJUSTIFICATIVA}`, httpOptions);
  }

  postBloquearCadastroCliFor(NRECNO: number, CCADASTRO: string, CJUSTIFICATIVA: string) {
    const httpOptions = this.utilService.filtrosHttpOptions({});
    return this.httpClient.post(`${this.url}/avaliacao/cliente-fornecedor/bloquear/${NRECNO}/${CCADASTRO}/${CJUSTIFICATIVA}`, httpOptions);
  }

  getClienteFornecedorLista(filtro: IFiltroAtualizacaoCadastro): Observable<AtualizacaoCadastroDto> {
    return this.httpClient.get<AtualizacaoCadastroDto>(`${this.url}/cliente-fornecedor/lista`, this.utilService.filtrosHttpOptions(filtro));
  }
}
